import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// === PWA Auto-Update System ===
const registerSW = async () => {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      updateViaCache: 'none', // Always fetch fresh SW from network
    });

    console.log('[PWA] Service Worker registered');

    // Check for updates every 60 seconds
    setInterval(() => {
      registration.update().catch(() => {});
    }, 60 * 1000);

    // Listen for new SW waiting to activate
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New version ready — tell it to activate immediately
          newWorker.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    });

    // When new SW takes control, reload the page silently
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      console.log('[PWA] New version detected — reloading...');
      window.location.reload();
    });

    // Listen for SW messages (version updates)
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_UPDATED') {
        if (!refreshing) {
          refreshing = true;
          console.log('[PWA] SW updated to v' + event.data.version + ' — reloading...');
          window.location.reload();
        }
      }
    });
  } catch (error) {
    console.error('[PWA] SW registration failed:', error);
  }
};

registerSW();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
